(ns rothko.editor.behaviours.tag
  (:require [com.rpl.specter :as sp]
            [rothko.editor.actions :as actions]
            [rothko.editor.document.navigators :as n]
            [rothko.editor.matcher :as m]
            [rothko.editor.space.transform :as space-transform]
            [rothko.editor.util :as util :include-macros true]
            [rothko.editor.tag.transform :as tag-transform]))

(def transform
  (sp/recursive-path
   [{:keys [tag space-edits? space-before-replacement?]}]
   _
   [(sp/collect-one :selection)
    n/token-unbias
    (n/if-caret?
     (util/cond-path

      (n/and-paths
       n/start-of-script?
       (n/context? [n/script-start-matcher [{:type :word}] [{:type :space} {:type :word}]]))
      (sp/multi-path
       (tag-transform/create-tag tag)
       (n/expand-selection
        {:shift-start-index 1
         :shift-end-index 1})
       (space-transform/create (space-transform/new-token space-edits?))
       n/token-rebias)

      n/start-of-script?
      (tag-transform/create-tag tag)

      (n/char-context? [#"  ?" n/caret-matcher n/end-of-word])
      (sp/multi-path
       (space-transform/create (space-transform/new-token space-edits?))
       (tag-transform/create-independent-tag tag))

      (n/char-context? [#"  ?" n/caret-matcher #"  ?"])
      (sp/multi-path
       n/split
       (tag-transform/create-independent-tag tag))

      (n/context? [m/?any (m/every (m/one-of {:type :word} {:type :edit})) m/?any])
      (sp/multi-path
       (n/expand-selection
        {:shift-start-index 1
         :shift-end-index 1})
       (space-transform/insert 0 (space-transform/new-token space-edits?))
       (tag-transform/create-tag tag)))

     (sp/if-path

      (n/context?
       [m/?any
        (m/every (m/one-of
                  {:type :word
                   :edited? m/absent}
                  {:type :space
                   :edited? m/absent}
                  {:type :tag
                   :system? true
                   :edited? m/absent}
                  {:type :word
                   :system? true
                   :edited? true}
                  {:type :edit
                   :system? true}
                  {:type :space-edit
                   :system? true}))
        m/?any])

      [space-transform/remove-dangling-spaces
       (sp/multi-path
        tag-transform/mark-as-tagged*
        (n/expand-selection
         {:new-start-index :end-index})
        n/move-selection-one-char-to-right
        (if space-before-replacement?
          (space-transform/insert 0 (space-transform/new-token space-edits?))
          [sp/DISPENSE
           actions/no-op])
        (tag-transform/create-tag tag)
        n/token-rebias)]))]))

(def mwe-start-token {:word "⟪" :type :tag :name :mwe-start})

(def mwe-end-token {:word "⟫" :type :tag :name :mwe-end})

(def mwe-transform
  [(sp/if-path
    (n/context?
     [m/?any
      (m/fn-matcher
       (fn [selected-tokens]
         (-> (filter #(= (:type %) :word) selected-tokens)
             count
             (> 1))))
      m/?any])
    [space-transform/remove-dangling-spaces
     (tag-transform/wrap-in-tokens mwe-start-token mwe-end-token)])])
